/**
 * Die Kostenstellenauswahl im Sheet `task-sheet` (`task-cost-center`, Spec
 * 06a, „Kostenstelle zeigt auf eine Entity und muss sichtbar sein"). Dünner
 * Wrapper um `components/EntityPicker` mit `allowClear` — bis Tor 2 baute
 * diese Datei einen eigenen zweiten Aufklapp-Baum nach (Simplifier-Fund,
 * `docs/work/006a-aufgaben-2a164c/findings.md`, „Tor 2"), jetzt teilt sie
 * sich Baum und Abfrage mit `access-invite-entity`.
 */

import { EntityPicker } from '@/components/EntityPicker'
import type { FieldError } from '@/components/FormField'

export interface CostCenterSelection {
  readonly id: string
  readonly label: string
}

interface TaskCostCenterFieldProps {
  readonly testId: string
  readonly errorPrefix: string
  readonly value: CostCenterSelection | null
  readonly onSelect: (entity: CostCenterSelection) => void
  readonly onClear: () => void
  readonly error: FieldError | undefined
}

export function TaskCostCenterField({
  testId,
  errorPrefix,
  value,
  onSelect,
  onClear,
  error,
}: TaskCostCenterFieldProps) {
  return (
    <EntityPicker
      testId={testId}
      label="Kostenstelle"
      apiField="cost_center_id"
      value={value}
      onSelect={onSelect}
      allowClear
      onClear={onClear}
      error={error}
      errorPrefix={errorPrefix}
    />
  )
}
